import { flexRender } from "@tanstack/react-table";
import { clsx } from "@/utils";
import { STICKY_RIGHT_CELL, readStickyColumn } from "../sticky";
import { DataTableCell as Cell } from "../types";

export interface DataTableCellProps<T extends object> extends React.ComponentProps<"td"> {
  cell: Cell<T, unknown>;
}

export const DataTableCell = <T extends object>({ cell, className, ...props }: DataTableCellProps<T>) => {
  const sticky = readStickyColumn(cell.column.columnDef);

  return (
    <td
      key={cell.id}
      className={clsx(className, sticky === "right" && STICKY_RIGHT_CELL)}
      style={{ width: cell.column.getSize() === Number.MAX_SAFE_INTEGER ? "auto" : cell.column.getSize() }}
      {...props}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
